package com.havn.app.features.leads.domain

import androidx.paging.PagingData
import com.havn.app.features.openhouses.domain.LeadTemperature
import kotlinx.coroutines.flow.Flow

interface LeadRepository {
    suspend fun leadsForAgent(agentId: String, agencyId: String? = null, actAsAgent: Boolean = false): Result<List<Lead>>
    suspend fun leadPage(agentId: String, agencyId: String? = null, query: String = "", offset: Int = 0, limit: Int = 20, actAsAgent: Boolean = false, inquiryOnly: Boolean = false): Result<List<Lead>>
    fun pagedLeadsForAgent(agentId: String, agencyId: String? = null): Flow<PagingData<Lead>>
    suspend fun leadDetail(agentId: String, leadId: String): Result<Lead>
    suspend fun inquiryLeadsForProperty(agentId: String, propertyId: String, limit: Int = 20): Result<List<Lead>>
    suspend fun createInquiryLead(
        agentId: String,
        propertyId: String,
        contactId: String,
        temperature: LeadTemperature = LeadTemperature.Warm,
        message: String? = null,
        notes: String? = null,
        source: String? = null
    ): Result<Lead>

    suspend fun createBuyerInquiry(
        agentId: String,
        contactId: String,
        location: String,
        radiusKm: Int?,
        budgetMin: Long?,
        budgetMax: Long?,
        timeline: String?,
        propertyType: String?,
        notes: String?, source: String?,
        temperature: LeadTemperature = LeadTemperature.Warm
    ): Result<Lead>

    suspend fun updateBuyerInquiry(
        agentId: String, leadId: String, location: String, radiusKm: Int?, budgetMin: Long?,
        budgetMax: Long?, timeline: String?, propertyType: String?, notes: String?, source: String?, temperature: LeadTemperature
    ): Result<Lead>

    suspend fun deleteInquiryLead(
        agentId: String,
        leadId: String
    ): Result<Unit>

    suspend fun updateLeadTemperature(
        agentId: String,
        leadId: String,
        temperature: LeadTemperature
    ): Result<Unit>

    suspend fun updateLeadNotes(
        agentId: String,
        leadId: String,
        notes: String
    ): Result<Lead>
}
